import { errors } from "@shared/errors";
import { PartialI18nLocale } from "../types";

export const jaLocale: PartialI18nLocale = {
  identity: { name: "日本語", flag: "🇯🇵" },

  command: {
    accept: "受け入れる",
    acceptWhat: "{{what}}を受け入れる",
    clear: "クリア",
    closeWhat: "{{what}}を閉じる",
    confirmWhat: "{{what}}を確認",
    editWhat: "{{what}}を変更する",
    logIn: "ログイン",
    logOut: "ログアウト",
    openWhat: "{{what}}を開く",
    reject: "拒否",
    rejectWhat: "{{what}}の拒否",
    resetWhat: "{{what}}のリセット",
    requestWhat: "{{what}}をリクエスト",
    save: "保存",
    search: "検索",
    selectWhat: "{{what}}を選択",
    sendWhat: "{{what}}の送信",
    sendingWhat: "{{what}}の送信中",
    setWhat: "{{what}}の設定",
    toggleWhat: "{{what}}の切り替え",
  },

  dashboard: {
    accepted: "承諾済み",
    acceptedPercent: "{{percent}}% 承諾済み",
    acceptedRejectedDetail: "承諾済み {{accepted}}件、拒否済み {{rejected}}件",
    acceptedRejectedIn: "{{month}}の承諾率",
    acceptanceRate: "承諾率",
    acceptanceLastDays: "直近{{count}}日間の承諾率",
    acceptanceLast30Days: "直近30日間の承諾率",
    acceptance: "承諾率",
    averageGuests: "平均ゲスト",
    averageGroupSize: "平均グループサイズ",
    averageRevenuePerGuest: "ゲストあたりの平均売上",
    cancellationNoShowRevenue: "キャンセル・無断欠席の売上",
    charts: "グラフ",
    graphScope: "グラフ単位",
    guests: "ゲスト人数",
    guestsIn: "{{month}}のゲスト人数",
    guestsLastDays: "直近{{count}}日間のゲスト人数",
    guestsLast30Days: "直近30日間のゲスト人数",
    guestsPerGroup: "グループあたりのゲスト人数",
    guestsPerReservation: "予約1件あたり{{count}}名",
    guestsOverTime: "ゲスト人数",
    month: "月",
    newMetric: "新規",
    noData: "この条件のダッシュボードデータはありません。",
    otherRevenue: "その他売上",
    pending: "保留中",
    pendingRequests: "保留中 {{count}}件",
    period: "期間",
    previousDays: "その前の{{count}}日間",
    previous30Days: "その前の30日間",
    previousMonth: "前月",
    rejected: "拒否済み",
    reservationRequestsOverTime: "予約リクエスト",
    revenue: "売上",
    revenueIn: "{{month}}の売上",
    revenueLastDays: "直近{{count}}日間の売上",
    revenueLast30Days: "直近30日間の売上",
    revenueOverTime: "売上",
    reservations: "予約",
    reservationsIn: "{{month}}の予約数",
    reservationsLastDays: "直近{{count}}日間の予約数",
    reservationsLast30Days: "直近30日間の予約数",
    searchPrompt: "検索ボタンをクリックすると、ここにダッシュボードデータが表示されます。",
    subtitle: "ベニューのパフォーマンス概要",
    table: "表",
    title: "ダッシュボード",
    total: "合計",
    totalRequests: "リクエスト合計",
    unanswered: "未回答",
    unansweredRequests: "未回答 {{count}}件",
    week: "週",
    viewMode: "表示モード",
    windowDays: "集計日数",
    year: "年",
  },

  date: {
    date: "{{year}}年{{month}}月{{day}}日",
    today: "今日",
    tomorrow: "明日",
  },

  error: {
    [errors.invalidCredentials]: "エラー　無効です",
    [errors.invalidPassword]: "エラー　無効なパスワード",
    [errors.missingCredentials]: "エラー　資格不足です",
    [errors.unauthorized]: "エラー　アクセス権限がありません",
    [errors.passwordRequestExpired]: "このパスワードリクエストは無効です。",
    [errors.passwordRequestUsed]:
      "このパスワード要求はすでに使用されています。新しいパスワードを再度設定してください。",
    [errors.passwordRequestFailed]:
      "このパスワード要求は処理できませんでした。新しいパスワードを再度設定してください。",
  },

  messages: {
    feedbackExplanation:
      "ベニューポータルに関するフィードバックをお聞かせください。これまでの操作状況はいかがでしょうか？どの点が難しい・使いにくいとお考えでしょうか？もしフィードバックを頂けましたら、引き続きシステムの改善に努めて参ります。",
    feedbackGratitude: "ご協力ありがとうございます。",
    inquiryExplanation:
      "予約に関してのお問い合わせでしょうか？弊社にお問い合わせ頂けましたらできる限り早くご回答いたします。",
  },

  notification: {
    empty: {
      body: "すべて確認済みです。時間をおいて再度ご確認ください。",
      title: "通知はまだありません",
    },
    feedback: {
      failedToSendFeedback: "フィードバックの送信失敗",
      sentFeedback: "フィードバックの送信完了",
    },
    inquiry: {
      failedToSendInquiry: "問い合わせの送信失敗",
      sentInquiry: "問い合わせの送信完了",
    },
    login: {
      failedToLogin: "ログインの失敗",
      loggedIn: "ログイン",
      loggedOut: "ログアウト",
    },
    password: {
      failedToSavePassword: "パスワードの保存失敗",
      failedToSendPasswordResetEmail: "パスワードの送信失敗",
      savedPassword: "保存されたパスワード",
      sentPasswordResetEmail: "パスワードをメールで送りました",
    },
    reservation: {
      acceptedReservation: "予約受け入れ完了",
      failedToUpdateReservation: "予約変更不可",
      rejectedReservation: "予約拒否",
      resetReservation: "予約のリセット",
    },
  },

  page: {
    dashboard: "ダッシュボード",
    feedback: "フィードバック",
    home: "ホーム",
    impersonate: "代理ログイン",
    notifications: "通知",
    settings: "設定",
  },

  passwordValidation: {
    confirmationPasswordMismatch: "パスワードは2回入力をお願いします。",
    passwordMinimumLength: "パスワードは8文字以上で設定をお願いします。",
    passwordNeedsLowercase:
      "最低1文字は半角小文字(アルファベット）でお願いします。",
    passwordNeedsSpecialCharacter:
      "最低1文字は特殊文字（! / ? 等）でお願いします。",
    passwordNeedsUppercase:
      "最低1文字は半角大文字(アルファベット）でお願いします。",
    passwordShould: "パスワードに関して",
  },

  reservation: {
    accepted: "承諾済み",
    answeredAt: "{{answer}}日",
    answeredAtWhen: "{{- when}}/{{answer}}",
    answeredAtWhenByWho: "{{- when}}/{{who}}によって{{answer}}",
    copyGroupId: "グループIDをコピー",
    endOfReservations: "予約はここまでです。",
    startOfReservations: "予約はここからです。",
    guest: "ゲスト人数",
    guide: "ガイド人数",
    noGuideAssigned: "ガイド未定",
    noReservations: "予約リクエストはありません",
    rejected: "拒否済み",
    reservationsCount: "{{count}}件の予約",
    reservationsFrom: "予約開始",
    pendingReservations: "回答が必要な予約",
    unanswered: "未回答",
    unconfirmedWhat: "{{what}}未回答",
    unknownGuestDetails: "現在、ゲスト内訳を確認中",
    unknownGuides: "{{guide}}{{numGuides}}名調整中",
    sentAt: "送信日時",
    updateRequestedAt: "最終更新日",
    venueUndecided: "ベニュ―未定",
    voiceover: {
      reservationDateTimeSummary: "予約日時: {{date}} {{time}}",
      reservationInfo:
        "人数: {{numGuests}} {{guestLabel}}, {{numGuides}} {{guideLabel}}, ガイド名: {{guideName}}",
    },
  },

  settings: {
    mode: { dark: "ダークモード", light: "ライトモード" },
    languageSettings: "言語設定",
    notificationSettings: "通知設定",
    reservationSettings: "予約設定",
    firstDayOfWeek: "週の開始日",
    password: {
      current: "現在のパスワード",
      forgot: "パスワードを忘れた",
      new: "新しいパスワード",
    },
    receiveNewReservationEmails: "新規予約依頼のメールを受け取る",
    receiveUpdatedReservationEmails: "予約変更のメールを受け取る",
    receiveCancelledReservationEmails: "予約キャンセルのメールを受け取る",
    newReservationEmailsOff:
      "新規予約依頼はベニューポータルにのみ表示されます。見逃さないよう定期的にご確認ください。",
  },

  nouns: {
    all: "全て",
    contact: "連絡先",
    email: "メール",
    feedback: "フィードバック",
    from: "から",
    inquiry: "問い合わせ",
    language: "言語",
    password: "パスワード",
    profile: "プロフィール",
    MagicalTrip: "マジカルトリップ",
    reservation: "予約",
    searchMenu: "予約検索",
    siteName: "ベニューポータル",
    theme: "テーマ",
    tour: "ツアー",
    until: "まで",
    venue: "ベニュー",
  },
};
